import React, { useEffect, useMemo } from 'react';
import { I18nextProvider } from 'react-i18next';
import PropTypes from 'prop-types';
import i18n from '../../helpers/i18n';
import getCountryFromTld from '../../helpers/country-from-tld';

const TranslationProvider = ({
  children,
  mode = 'country',
  platform,
}) => {
  const translationKey = useMemo(() => {
    if (mode === 'platform') {
      return platform;
    }
    return getCountryFromTld();
  }, [mode, platform]);

  useEffect(() => {
    if (translationKey) {
      i18n.changeLanguage(translationKey);
    }
  }, [translationKey]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

TranslationProvider.propTypes = {
  children: PropTypes.element.isRequired,
  mode: PropTypes.oneOf(['country', 'platform']),
  platform: PropTypes.string,
};

TranslationProvider.defaultProps = {
  mode: 'country',
  platform: undefined,
};

export default TranslationProvider;
